import { useEffect, useState } from "react";

import { getOrganisationBranch } from "../services/organizationBranches";
import { CompanyEntityData } from "../services/organizationBranches/models";

const useCompanyEntityData = (organizationBranchId: number) => {
    const [result, setResult] = useState<CompanyEntityData>({
        companyCard: null,
        isCompanyCardLocked: false
    });
    const [forceReload, setForceReload] = useState(false);

    const reload = async () => {
        const { organizationBranch, err } = await getOrganisationBranch({
            organizationBranchId
        });
        setResult(organizationBranch.companyEntityData);
        setForceReload(false);
    }

    useEffect(() => {
        reload();
    }, [])

    useEffect(() => {
        if(!forceReload) return;
        reload();
    }, [forceReload]);


    return [result, setForceReload] as [CompanyEntityData, (v: boolean) => void]
};
export default useCompanyEntityData
